// *******************************************************************************
// Switch Tab
// *******************************************************************************

attachEvent('.transport-timetable__table-title button', 'click', (el) => {
  const parentEle = el.target.closest('.transport-timetable');
  const firstTab = parentEle.querySelector('[data-tab-link]');
  const firstContent = parentEle.querySelector('[data-tab-content]');
  removeActiveClass(parentEle.querySelectorAll('[data-tab-link]'));
  removeActiveClass(parentEle.querySelectorAll('[data-tab-content]'));
  firstTab.classList.add('is-active');
  firstContent.classList.add('is-active');
});

// Timer
const initTimer = () => {
  document.querySelectorAll('[data-timer-parent] [data-timer]').forEach((ele) => {
    let sec = 0;

    ele.textContent = '00:00';

    setInterval(() => {
      sec++;
      ele.textContent = `${String(Math.floor(sec / 60)).padStart(2, '0')}:${String(sec % 60).padStart(2, '0')}`;
    }, 1000);
  });
};

initTimer();
